const hostBlockConfig: Record<string, any> = {
  'ta.bigolive.tv': {
    'd1zna09pvtqt8v.cloudfront.net': 'd2ymiio14rfyj6.cloudfront.net',
    'agent-oss.linhty.xyz': 'ta.linhty.xyz',
    'agent-oss.hzmk.site': 'ta.hzmk.site',
    'agent-oss.bigoapp.tv': 'ta.bigoapp.tv',
  },
  'activity.bigo.tv': {
    'd1zna09pvtqt8v.cloudfront.net': 'd3p4knfuab3k5w.cloudfront.net',
    'agent-oss.linhty.xyz': 'activity.weihuitel.com',
    'agent-oss.hzmk.site': 'activity.weihuitel.com',
    'agent-oss.bigoapp.tv': 'actan.owxd.xyz',
  },
  'https-api.bigolive.tv': {
    'd1zna09pvtqt8v.cloudfront.net': 'd3itzctge2378p.cloudfront.net',
    'agent-oss.linhty.xyz': 'ta-https-api.ukyuh.tech',
    'agent-oss.hzmk.site': 'ta-https-api.ukyuh.tech',
    'agent-oss.bigoapp.tv': 'ta-https-api.bigoapp.tv',
  },
  'www.bigo.tv': {
    'd1zna09pvtqt8v.cloudfront.net': 'd1e5ml8xtgdvj3.cloudfront.net',
    'agent-oss.linhty.xyz': 'm.linhty.xyz',
    'agent-oss.hzmk.site': 'm.hzmk.site',
    'agent-oss.bigoapp.tv': 'www.bigoapp.tv',
  },
};

// 处理域名替换
export function replaceHost(replaceUrl: string) {
  const urlReg =
    /^(http:\/\/|https:\/\/|wss:\/\/|\/\/)([a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?)/;
  const temp = urlReg.exec(replaceUrl);
  if (!(temp && temp[2])) return replaceUrl;
  const config = hostBlockConfig[temp[2]] || {};
  const curDomain = window.location.hostname;
  const newHost = typeof config === 'string' ? config : config[curDomain];
  // 命中了当前域名
  if (newHost) {
    return replaceUrl.replace(temp[2], newHost);
  }
  if (config.other) {
    // 如果other存在，其他国家统一替换
    return replaceUrl.replace(temp[2], config.other);
  }
  return replaceUrl;
}
